import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { useSelectorCountdownTimeoutSecs } from '../../../../../../configuration';
import {
    fetchGetExtendSessionRequest, fetchGetSignOutRequest, sessionLogout
} from '../../../../../../session';

export type UseSessionTimeoutHook = {
    isLoading: boolean
    durationSecs: number
    onExtendSession: () => any
    onExpiredCountdown: () => any
    onSignIn: () => any
    isCountdownVisible: boolean
};

export const useSessionTimeout = (): UseSessionTimeoutHook => {
    const durationSecs = useSelectorCountdownTimeoutSecs();
    const [isLoading, setIsLoading] = useState(false);
    const [isCountdownVisible, setIsCountdownVisible] = useState(true);
    const dispatch = useDispatch();
    const handleExpiredCountdown = () => {
        setIsCountdownVisible(false);
        dispatch(fetchGetSignOutRequest());
    };
    const handleSignIn = () => {
        // Sign in is handled through logging out,
        // and then using the sign in app to log back in :/
        dispatch(sessionLogout());
    };
    const handleResolveExtend = () => {
        setIsLoading(false);
    };
    const handleRejectExtend = () => {
        handleSignIn();
    };
    const handleExtendSession = async () => {
        if (isLoading) return;

        setIsLoading(true);

        const sessionRequest = dispatch<any>(fetchGetExtendSessionRequest());

        sessionRequest
            .then(handleResolveExtend)
            .catch(handleRejectExtend);
    };

    return {
        durationSecs,
        isLoading,
        isCountdownVisible,
        onExtendSession: handleExtendSession,
        onExpiredCountdown: handleExpiredCountdown,
        onSignIn: handleSignIn
    };
};
